import _Object$create from 'babel-runtime/core-js/object/create';

var NAMESPACE = 'td';

var CarouselItem = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('transition', { attrs: { "name": "fade" } }, [_c('li', { directives: [{ name: "show", rawName: "v-show", value: _vm.active, expression: "active" }], staticClass: "td-carousel__item", class: _vm.computeClass }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-carousel-item',
  props: {
    customClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  mounted: function mounted() {
    var parent = this.$parent;
    if (process.env.NODE_ENV === 'development' && parent.$options._componentTag !== 'td-carousel') {
      console.warn("CarouselItem's parent must be Carousel");
    }
  },

  computed: {
    computeClass: function computeClass() {
      return this.customClass.split(/\s+/).reduce(function (pre, cur) {
        if (cur !== 'is-active') {
          pre[cur] = true;
        }
        return pre;
      }, _Object$create(null));
    }
  }
};

CarouselItem.install = function (Vue) {
  Vue.component(CarouselItem.name, CarouselItem);
};

export default CarouselItem;
